import { Route, Routes } from 'react-router-dom';
import { NotFound, ReversalReason } from '@pages';
import { Protected } from '@components';

function RoutesReversalReason() {
  return (
    <Protected>
      <Routes>
        <Route index element={<ReversalReason />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}

export default RoutesReversalReason;
